import { Button } from "@aiw/ui";
import { signInWithMicrosoft } from "../lib/auth";

export function SignIn() {
  return (
    <main className="grid min-h-screen place-items-center bg-background">
      <div className="w-full max-w-sm rounded-lg border bg-card p-6 text-center">
        <img src="/brand/artemis-lockup-on-light.svg" alt="Artemis Flooring" width={300} height={56} className="mx-auto h-11 w-auto" />
        <h1 className="mt-4 text-xl font-semibold">Artemis CRM</h1>
        <p className="mt-1 text-sm text-muted-foreground">Staff sign in with their Artemis Microsoft account.</p>
        <Button className="mt-4 w-full" onClick={() => void signInWithMicrosoft()}>Sign in with Microsoft</Button>
      </div>
    </main>
  );
}
